import React, { useState } from "react";
import DashboardSide from "../dashboard/DashboardSide";
import IntegrationCenter from "./IntegrationCenter";
import MobileMenu from "../dashboard/MobileMenu";

export default function Integration() {
  const [modal, setModal] = useState(false);

  return (
    <div className="h-full bg-[#f6f6f6] flex items-center justify-center">
      <DashboardSide />
      {modal && <MobileMenu setModal={setModal} />}
      <IntegrationCenter setModal={setModal} />
    </div>
  );
}
